const VIDEO_CHECKLIST_ITEMS = [
  'Mention sanitaire « L\'abus d\'alcool est dangereux pour la santé » visible, lisible et durable à l\'écran — pas un flash fugace.',
  'Aucune mise en scène de consommation : pas de gorgée, trinquage, ivresse ou descente filmés.',
  'Aucun univers susceptible d\'attirer les mineurs : codes, musique ou personnages enfantins.',
  'Aucune association à la performance, la séduction, la réussite sociale ou la conduite automobile.',
  'Aucune incitation à la consommation : pas de défi, « sans modération » ou formule encourageante.',
  'Divulgation claire du partenariat commercial si la vidéo est sponsorisée (#partenariat, #collaboration).',
  'Paramétrage de diffusion réservé aux adultes (18+ sur Meta, YouTube, TikTok).',
];

interface Props {
  compact?: boolean;
}

/**
 * Liste informative (non interactive) des points à respecter dans la vidéo
 * elle-même. L'analyse automatique ne porte que sur la légende/les hashtags ;
 * ces points relèvent du montage et de la diffusion, donc de l'utilisateur.
 * Affichée uniquement dans le rapport d'analyse (pas sur l'écran de saisie).
 */
export default function VideoComplianceChecklist({ compact = false }: Props) {
  return (
    <div className={`rounded-xl border border-slate-200 dark:border-slate-800 shader:border-white/10
      bg-slate-50 dark:bg-slate-900/40 shader:bg-white/5 shader:backdrop-blur-xl ${compact ? 'p-3' : 'p-4'}`}>
      <div className="flex items-center gap-2 mb-1">
        <svg className="w-4 h-4 shrink-0 text-violet-600 dark:text-violet-300 shader:text-violet-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
          <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
          <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
          <path d="m9 14 2 2 4-4" />
        </svg>
        <p className="text-sm font-medium text-slate-700 dark:text-slate-200 shader:text-white">
          À respecter impérativement dans la vidéo
        </p>
      </div>
      <p className="text-xs text-slate-500 dark:text-slate-400 shader:text-white/50 mb-3">
        L'analyse automatique porte sur votre légende et vos hashtags. Ces points concernent la vidéo elle-même (montage, diffusion) — ils relèvent de votre responsabilité et n'affectent pas le score.
      </p>
      <ul className="space-y-1.5">
        {VIDEO_CHECKLIST_ITEMS.map((item, i) => (
          <li key={i} className="flex items-start gap-2.5">
            <span className="mt-0.5 shrink-0 text-violet-500 dark:text-violet-400 shader:text-violet-300">
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6 9 17l-5-5" />
              </svg>
            </span>
            <span className="text-sm text-slate-600 dark:text-slate-300 shader:text-white/90">
              {item}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
